interface PlusIconProps {
  fill?: string;
}

const PlusIcon = ({ fill }: PlusIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00008 2.66669C8.36827 2.66669 8.66675 2.96516 8.66675 3.33335V7.33335H12.6667C13.0349 7.33335 13.3334 7.63183 13.3334 8.00002C13.3334 8.36821 13.0349 8.66669 12.6667 8.66669H8.66675V12.6667C8.66675 13.0349 8.36827 13.3334 8.00008 13.3334C7.63189 13.3334 7.33341 13.0349 7.33341 12.6667V8.66669H3.33341C2.96522 8.66669 2.66675 8.36821 2.66675 8.00002C2.66675 7.63183 2.96522 7.33335 3.33341 7.33335H7.33341V3.33335C7.33341 2.96516 7.63189 2.66669 8.00008 2.66669Z"
        fill={fill ?? "#015C9A"}
      />
    </svg>
  );
};

export default PlusIcon;
